/* Wolfborn definition range v3. Extends the approved v2 controller without
 * changing Electrician presets, checkout settings, or the frame selector. */
(() => {
  'use strict';
  customElements.whenDefined('wb-definition-product').then(() => {
    const Product = customElements.get('wb-definition-product');
    const proto = Product.prototype;
    if (proto.wbRangeV3) return;
    proto.wbRangeV3 = true;
    const original = {
      render: proto.render,
      measure: proto.measure,
      svgText: proto.svgText,
      syncProperties: proto.syncProperties
    };
    const v3 = instance => Number(instance.active?.preset?.version) >= 3;
    const titleSize = instance => {
      const value = Number(instance.active?.preset?.titleFontSize || 86);
      return Number.isFinite(value) && value >= 40 && value <= 86 ? value : 86;
    };
    const initialsSize = instance => ['Mm', 'Ww'].includes(instance.active?.preset?.initials) ? 45 : 66;
    const mappedSize = (instance, size) => !v3(instance) ? size : size === 86 ? titleSize(instance) : size === 66 ? initialsSize(instance) : size;
    proto.measure = function(text, size, italic) {
      return original.measure.call(this, text, mappedSize(this, size), italic);
    };
    proto.svgText = function(x, y, value, size, italic) {
      return original.svgText.call(this, x, y, value, mappedSize(this, size), italic);
    };
    proto.syncProperties = function(values, custom) {
      original.syncProperties.call(this, values, custom);
      // Public wording is visible in Shopify checkout and order-item details.
      // Keep the numbered lines too, so intentional line breaks are unambiguous.
      const preset = this.active?.preset;
      const host = this.querySelector('[data-properties]');
      if (preset && host) {
        const lines = custom
          ? Array.from({length: 6}, (_, i) => values['line' + (i + 1)] || '')
          : [...(preset.lines || [])];
        while (lines.length && lines[lines.length - 1] === '') lines.pop();
        const wording = document.createElement('input');
        wording.type = 'hidden';
        wording.name = 'properties[Definition wording]';
        wording.value = lines.join(custom ? '\n' : ' ');
        host.insertBefore(wording, host.querySelector('input[name="properties[Definition line 1]"]'));
      }
      if (!v3(this)) return;
      const input = this.querySelector('input[name="properties[_Definition layout]"]');
      if (!input) return;
      try {
        const data = JSON.parse(input.value);
        data.version = 3;
        data.titleFontSize = titleSize(this);
        data.initialsFontSize = initialsSize(this);
        input.value = JSON.stringify(data);
      } catch (_) { /* Leave the existing production data intact. */ }
    };
    proto.render = function() {
      original.render.call(this);
      const preset = this.active?.preset;
      if (!preset || !this.photo || !this.overlay) return;
      if (!preset.custom && preset.renderMockup && this.config.blankUrl) {
        const values = { title: preset.title, autoInitials: preset.initials, seeAlso: preset.seeAlso || '' };
        (preset.lines || []).forEach((line, i) => { values['line' + (i + 1)] = line; });
        this.photo.src = this.config.blankUrl;
        this.photo.alt = preset.title + ' — ' + this.active.name + ', framed clear acrylic definition print.';
        this.overlay.removeAttribute('hidden');
        this.renderOverlay(values);
      } else {
        // SVG has no standard reflected `hidden` property: update the real
        // attribute so the existing [hidden] CSS and accessibility stay in sync.
        this.overlay.toggleAttribute('hidden', Boolean(this.overlay.hidden));
      }
    };
    const refresh = scope => {
      scope.querySelectorAll('wb-definition-product').forEach(el => {
        if (el.initialized && el.active) el.render();
      });
    };
    refresh(document);
    document.fonts?.ready.then(() => refresh(document));
    document.addEventListener('shopify:section:load', event => refresh(event.target));
  });
})();
